export default "__VITE_ASSET__B1YZj5fx__"